<template>
  <ul class="app-header-nav" v-if="$route.path !== '/login'">
    <li>
      <RouterLink target="_blank" to="/home" router-link-exact-active
        >首页</RouterLink
      >
    </li>
    <li>
      <RouterLink target="_blank" to="/news">资讯</RouterLink>
    </li>
    <li><RouterLink target="_blank" to="/video">课程</RouterLink></li>
    <li><RouterLink target="_blank" to="/books">图书</RouterLink></li>
    <li><RouterLink target="_blank" to="/tests">试题</RouterLink></li>
    <li><RouterLink target="_blank" to="/read">资料</RouterLink></li>
    <li><RouterLink target="_blank" to="/about">关于我们</RouterLink></li>
  </ul>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
export default {
  name: "AppHeaderNav",
  setup() {
    const route = useRoute();
    /* const getPath = (path) => {
      console.log(path);
    }; */
    return {};
  },
};
</script>

<style scoped lang="less">
.app-header-nav {
  width: 820px;
  display: flex;
  padding-left: 45px;
  position: relative;
  z-index: 998;
  li {
    margin-right: 30px;
    width: 75px;
    text-align: center;
    a {
      font-size: 18px;
      line-height: 45px;
      font-weight: bold;
      height: 45px;
      display: inline-block;
    }
    &:hover {
      a {
        color: @shColor;
        border-bottom: 1px solid @shColor;
      }
    }
    .router-link-exact-active {
      color: @shColor;
      border-bottom: 1px solid @shColor;
    }
  }
}
</style>
